import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
type CtaBlockProps = {
  label: string;
  note?: string;
  tone?: 'light' | 'dark';
  showCountdown?: boolean;
  showScarcity?: boolean;
  showCurrency?: boolean;
  id?: string;
};
export function CtaBlock({
  label,
  note,
  tone = 'light',
  showCountdown = true,
  showScarcity = false,
  showCurrency = true,
  id
}: CtaBlockProps) {
  const isDark = tone === 'dark';
  return <div id={id} className="flex w-full flex-col items-center gap-3" data-id="element-102" data-mp="24n2tbqbj82qm">
      <CtaButton label={label} data-id="element-103" data-mp="1qomdn9voz1wc" />

      {note && <p className={`max-w-md text-center text-[11px] font-bold uppercase tracking-[0.12em] sm:text-xs ${isDark ? 'text-white/70' : 'text-navy-900/60'}`} data-id="element-104" data-mp="1uqpr241x8gk9">
          {note}
        </p>}

      {showCountdown && <div className="pt-1" data-id="element-105" data-mp="jd5iiok6zyxz">
          <Countdown tone={tone} data-id="element-106" data-mp="1037bkqj8ajcy" />
        </div>}

      {showScarcity && <ScarcityBar tone={tone} data-id="element-107" data-mp="105jsd0d92nof" />}

      {showCurrency && <p className={`flex items-center justify-center gap-1.5 text-center text-[11px] leading-snug ${isDark ? 'text-white/55' : 'text-navy-900/55'}`} data-id="element-108" data-mp="v5e6k0tnvve9">
          <GlobeIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-109" data-mp="151h6d011jhy1" />
          Il cambio di valuta è automatico secondo il tuo paese
        </p>}
    </div>;
}
export function CtaGuaranteeRow({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const items = ['Accesso immediato', 'Pagamento unico', 'Accesso a vita', 'Garanzia 7 giorni'];
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[11px] font-semibold sm:text-xs ${tone === 'dark' ? 'text-white/70' : 'text-navy-900/65'}`} data-id="element-110" data-mp="1nsrvpcr4bmnt">
      {items.map(item => <li key={item} className="flex items-center gap-1" data-id="element-111" data-mp="1wvau9knvfd49">
          <CheckIcon className="h-3.5 w-3.5 shrink-0 text-gold-500" aria-hidden="true" data-id="element-112" data-mp="uh39bs1bc97k" />
          {item}
        </li>)}
    </ul>;
}